import styled from '@emotion/styled'
import { colors } from '../../../../../../__styling/settings/colors'
import { calcRem } from '../../../../../../__styling/style-functions/calc-rem'
import { breakpoint } from '../../../../../../__styling/style-functions'
import { Equaliser } from '../Equaliser/Equaliser'
import { Product } from '@news-mono/web-common'

export const StyledOnAir = styled('div')<{ showOnAirIconOnMobile?: boolean }>(
    (props) => ({
        display: props.showOnAirIconOnMobile ? 'inline-block' : 'none',
        padding: calcRem(0, 5),
        transform: 'skew(-10deg)',
        backgroundColor: colors.white,
        fontFamily: props.theme.fonts.sansSerif,
        fontWeight: 700,
        lineHeight: 1,
        textTransform: 'uppercase',

        [breakpoint('xxs')]: {
            display: 'inline-block',
        },
    }),
    ({ theme }) =>
        theme.kind === Product.TheWest && {
            color: colors.thewest.westblue,
        },
    ({ theme }) =>
        theme.kind === Product.PerthNow && {
            color: colors.perthnow.greyBasalt,
        },
)

export const StyledEqualiser = styled(Equaliser)({
    display: 'inline-block',
    marginLeft: calcRem(10),
    overflow: 'hidden',

    [breakpoint('sm')]: {
        marginLeft: calcRem(2),
    },
})

export const StyledOnAirContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
})
